export const searchItems = [
  // 展示名称
  {
    label: '关键字',
    type: 'input',
    decorator: ['keyword'],
    placeholder: '请输入名称/ID'
  },
]
